import React, { Component } from 'react';
import PropTypes from 'prop-types';
// redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { fetchCategoryData, fetchProductData, fetchNewsData, fetchLocationData, fetchPageData, fetchContactData, fetchBannerData, fetchHomeslideshowData } from '../actions';
import './App.css';
import Header from '../components/Header';
import Main from '../components/Main';
import Footer from '../components/Footer';
import '../scss/Bulma.css';
import { configureAnchors } from 'react-scrollable-anchor';
import "ie-array-find-polyfill";

// Offset all anchors by -60 to account for a fixed header
// and scroll more quickly than the default 400ms
configureAnchors({offset: -100, scrollDuration: 400});

class App extends Component {
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(fetchHomeslideshowData());
    dispatch(fetchBannerData());
    dispatch(fetchPageData());
    dispatch(fetchNewsData());
    dispatch(fetchLocationData());
    dispatch(fetchContactData());
    dispatch(fetchCategoryData());
    dispatch(fetchProductData());
  }

  render() {
    let title = "Stihl 台灣";
    let description = "德商美最時貿易公司於1997年起代理進口世界第一鏈鋸領導品牌-STIHL®，除了專業農機具相關產品-鏈鋸機、割草機、籬笆剪、吹葉機、噴霧機、切割機及高壓清洗機，更有充電式產品以滿足更多元化的需求。";
    this.props.pages.forEach((page) => {
      if(page.name === 'web_meta_title'){
        title = page.content;
      } else if(page.name === 'web_meta_description'){
        description = page.content;
      }
    });

    return (
        <div className="App">
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
          </Helmet>
          <Header />
          <Main />
          <Footer />
        </div>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  pages: state.pages,
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js